import { t as translate } from '../../core';

export const label = (key: string) => translate(`management-report.label.${key}`);
export const title = (key: string) => translate(`management-report.title.${key}`);
